import { useState } from "react";
import { TpTooltip } from '@tranquility-ai/theme-components/tooltip';
import { Button } from '@tranquility-ai/theme-components/button';
import { ImageBrokenIcon, ClipboardTextIcon } from "@phosphor-icons/react";

const ImageNotFound = (props: { id: number, src: string, isThumbnail?: boolean, disableTooltip?: boolean }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(props.src).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    });
  };

  const brokenImage = (
    <div className="flex flex-col items-center justify-center min-w-[60px] min-h-[60px]">
      <ImageBrokenIcon weight={props.isThumbnail ? 'thin' : 'duotone'} size={props.isThumbnail ? 60 : 100} />
      {!props.isThumbnail && (
        <div className="text-white/65 text-lg">Image not found or empty</div>
      )}
    </div>
  );

  if (props.disableTooltip) {
    return (
      <div className={`flex flex-col items-center justify-center w-auto h-auto ${props.isThumbnail ? '' : 'p-[30px]'}`}>
        {brokenImage}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center w-auto h-auto ${props.isThumbnail ? '' : 'p-[30px]'}`}>
      <TpTooltip
        content={
          <div className="flex flex-col gap-1 items-start justify-start w-full h-auto">
          <textarea className="w-full h-auto line-clamp-1 p-1 bg-white/20 rounded-sm border border-black/5 border-dashed resize-none overflow-y-scroll" value={props.src} readOnly />
          <Button
          iconOnly
          size="sm"
          style={copied ? "solid" : "text"}
          color={copied ? "accent" : "light"}
          background="inverse"
          className="mr-[-6px]"
          aria-label={copied ? "Copied" : "Copy image path"}
          onClick={handleCopy}
          >
          <ClipboardTextIcon weight="duotone" />
          </Button>
          </div>
        }
        sideOffset={-5}
      >
        <div className="flex flex-col items-center justify-center hover:cursor-help min-w-[60px] min-h-[60px]">
          <ImageBrokenIcon weight={props.isThumbnail ? 'thin' : 'duotone'} size={props.isThumbnail ? 60 : 100} />
          {!props.isThumbnail && (
            <div className="text-white/65 text-lg">Image not found or empty</div>
          )}
        </div>
      </TpTooltip>
    </div>
  );
};

export default ImageNotFound;
